import { useQuery } from "@tanstack/react-query"
import { getWalletDetails, getWalletHistory, getCoinPackages } from "../../redux/wallet/walletAction"


export const useWalletDetails = () => {
    return useQuery({
        queryKey: ["wallet", "details"],
        queryFn: getWalletDetails
    })
}

export const useWalletHistory = ({ page, startDate, endDate }) => {
    return useQuery({
        queryKey: ["wallet", "history", startDate, endDate, `${page}`],
        queryFn: () => getWalletHistory({ page, startDate, endDate }),
    })
}

export const useCoinPackages = () => {
    return useQuery({
        queryKey: ["wallet", "coin-packages"],
        queryFn: getCoinPackages,
        staleTime: 5 * 60 * 1000,
    })
}